export function isExcludedLegalYandexFields(fieldKey: string): boolean {
    return fieldKey.endsWith("_id") || fieldKey === LegalYandexWordFields.ya_is_beyond;
}

export enum LegalYandexWordFields {
    ya_name = "ya_name",
    ya_full_name = "ya_full_name",
    ya_bg = "ya_bg",
    ya_bu = "ya_bu",
    ya_country_code = "ya_country_code",
    ya_country = "ya_country",
    ya_perimeter = "ya_perimeter",
    ya_id = "ya_id",
    ya_inn = "ya_inn",
    ya_ogrn = "ya_ogrn",
    ya_address = "ya_address",
    ya_address_eng = "ya_address_eng",
    ya_reg_num = "ya_reg_num",
    ya_eng_name_full = "ya_eng_name_full",
    ya_eng_name_short = "ya_eng_name_short",
    ya_reg_date = "ya_reg_date",
    ya_kpp = "ya_kpp",
    ya_kpp_main = "ya_kpp_main",
    ya_oktmo = "ya_oktmo",
    ya_okpo = "ya_okpo",
    ya_it_num = "ya_it_num",
    ya_it_start_date = "ya_it_start_date",
    ya_is_beyond = "ya_is_beyond",
    ya_system_name = "ya_system_name",
    ya_org_id = "ya_org_id",
    ya_general_visa_login = "ya_general_visa_login",
    ya_general_visa_fio = "ya_general_visa_fio",
    ya_general_visa_familyio = "ya_general_visa_familyio",
    ya_general_visa_iofamily = "ya_general_visa_iofamily",
    ya_general_visa_gen = "ya_general_visa_gen",
    ya_general_visa_dat = "ya_general_visa_dat",
    ya_general_visa_acc = "ya_general_visa_acc",
    ya_general_visa_inst = "ya_general_visa_inst",
    ya_general_visa_prepos = "ya_general_visa_prepos",
    ya_general_visa_job = "ya_general_visa_job",
    ya_general_visa_job_gen = "ya_general_visa_job_gen",
    ya_general_visa_job_dat = "ya_general_visa_job_dat",
    ya_general_visa_job_acc = "ya_general_visa_job_acc",
    ya_general_visa_job_inst = "ya_general_visa_job_inst",
    ya_general_visa_job_prepos = "ya_general_visa_job_prepos",
    ya_general_visa_last_name = "ya_general_visa_last_name",
    ya_general_visa_first_name = "ya_general_visa_first_name",
    ya_general_visa_middle_names = "ya_general_visa_middle_names",
    ya_general_visa_birth_date = "ya_general_visa_birth_date",
    ya_general_visa_inn = "ya_general_visa_inn",
    ya_general_visa_snils = "ya_general_visa_snils",
    ya_general_visa_citizenship = "ya_general_visa_citizenship",
    ya_org_region = "ya_org_region",
    ya_org_town = "ya_org_town",
    ya_org_postal_code = "ya_org_postal_code",
    ya_org_combination = "ya_org_combination",
    ya_account_currency = "ya_account_currency",
    ya_account_type = "ya_account_type",
    ya_bank_name = "ya_bank_name",
    ya_bic = "ya_bic",
    ya_payment_account = "ya_payment_account",
    ya_corr_account = "ya_corr_account",
    ya_bank_iban = "ya_bank_iban",
    ya_bank_swift = "ya_bank_swift",
    ya_bank_chips = "ya_bank_chips",
    ya_bank_aba = "ya_bank_aba",
    ya_account_transit = "ya_account_transit",
    ya_bank_address = "ya_bank_address",
    ya_bank_intermediary_bic = "ya_bank_intermediary_bic",
    ya_correspondent_bank_swift = "ya_correspondent_bank_swift",
    ya_correspondent_bank = "ya_correspondent_bank",
    ya_correspondent_bank_address = "ya_correspondent_bank_address",
    ya_correspondent_bank_account = "ya_correspondent_bank_account",
    ya_bank_inn = "ya_bank_inn",
    ya_bank_mfo = "ya_bank_mfo",
    ya_bank_comment = "ya_bank_comment",
}
